export enum RaceStatus {
  Starting = 'STARTING',
  InProgress = 'IN_PROGRESS',
  Complete = 'COMPLETE',
  Dnf = 'DNF',
  Dnq = 'DNQ',
  Dns = 'DNS',
}

export enum NationalFlagIds {
  ABW = 'abw-national-flag', // Aruba
  AFG = 'afg-national-flag', // Afghanistan
  AGO = 'ago-national-flag', // Angola
  AIA = 'aia-national-flag', // Anguilla
  ALA = 'ala-national-flag', // Åland Islands
  ALB = 'alb-national-flag', // Albania
  AND = 'and-national-flag', // Andorra
  ARE = 'are-national-flag', // United Arab Emirates (the)
  ARG = 'arg-national-flag', // Argentina
  ARM = 'arm-national-flag', // Armenia
  ASM = 'asm-national-flag', // American Samoa
  // ATA = 'ata-national-flag', // Antarctica - has no official flag
  // ATF = 'atf-national-flag', // French Southern Territories (the) - FLAG IS MISSING
  ATG = 'atg-national-flag', // Antigua and Barbuda
  AUS = 'aus-national-flag', // Australia
  AUT = 'aut-national-flag', // Austria
  AZE = 'aze-national-flag', // Azerbaijan
  BDI = 'bdi-national-flag', // Burundi
  BEL = 'bel-national-flag', // Belgium
  BEN = 'ben-national-flag', // Benin
  BES = 'bes-national-flag', // Bonaire, Sint Eustatius and Saba
  BFA = 'bfa-national-flag', // Burkina Faso
  BGD = 'bgd-national-flag', // Bangladesh
  BGR = 'bgr-national-flag', // Bulgaria
  BHR = 'bhr-national-flag', // Bahrain
  BHS = 'bhs-national-flag', // Bahamas (the)
  BIH = 'bih-national-flag', // Bosnia and Herzegovina
  BLM = 'blm-national-flag', // Saint Barthélemy
  BLR = 'blr-national-flag', // Belarus
  BLZ = 'blz-national-flag', // Belize
  BMU = 'bmu-national-flag', // Bermuda
  BOL = 'bol-national-flag', // Bolivia (Plurinational State of)
  BRA = 'bra-national-flag', // Brazil
  BRB = 'brb-national-flag', // Barbados
  BRN = 'brn-national-flag', // Brunei Darussalam
  BTN = 'btn-national-flag', // Bhutan
  BVT = 'bvt-national-flag', // Bouvet Island
  BWA = 'bwa-national-flag', // Botswana
  CAF = 'caf-national-flag', // Central African Republic (the)
  CAN = 'can-national-flag', // Canada
  CCK = 'cck-national-flag', // Cocos (Keeling) Islands (the)
  CHE = 'che-national-flag', // Switzerland
  CHL = 'chl-national-flag', // Chile
  CHN = 'chn-national-flag', // China
  CIV = 'civ-national-flag', // Côte d'Ivoire
  CMR = 'cmr-national-flag', // Cameroon
  COD = 'cod-national-flag', // Congo (the)
  COG = 'cog-national-flag', // Congo (the Democratic Republic of the)
  COK = 'cok-national-flag', // Cook Islands (the)
  COL = 'col-national-flag', // Colombia
  COM = 'com-national-flag', // Comoros (the)
  CPV = 'cpv-national-flag', // Cabo Verde
  CRI = 'cri-national-flag', // Costa Rica
  CUB = 'cub-national-flag', // Cuba
  CUW = 'cuw-national-flag', // Curaçao
  // CXR = 'cxr-national-flag', // Christmas Island - FLAG IS MISSING
  CYM = 'cym-national-flag', // Cayman Islands (the)
  CYP = 'cyp-national-flag', // Cyprus
  CZE = 'cze-national-flag', // Czechia
  DEU = 'deu-national-flag', // Germany
  DJI = 'dji-national-flag', // Djibouti
  DMA = 'dma-national-flag', // Dominica
  DNK = 'dnk-national-flag', // Denmark
  DOM = 'dom-national-flag', // Dominican Republic (the)
  DZA = 'dza-national-flag', // Algeria
  ECU = 'ecu-national-flag', // Ecuador
  EGY = 'egy-national-flag', // Egypt
  ERI = 'eri-national-flag', // Eritrea
  // ESH = 'esh-national-flag', // Western Sahara - has no official flag
  ESP = 'esp-national-flag', // Spain
  EST = 'est-national-flag', // Estonia
  ETH = 'eth-national-flag', // Ethiopia
  FIN = 'fin-national-flag', // Finland
  FJI = 'fji-national-flag', // Fiji
  FLK = 'flk-national-flag', // Falkland Islands (the) [Malvinas]
  FRA = 'fra-national-flag', // France
  FRO = 'fro-national-flag', // Faroe Islands (the)
  FSM = 'fsm-national-flag', // Micronesia (Federated States of)
  GAB = 'gab-national-flag', // Gabon
  GBR = 'gbr-national-flag', // United Kingdom of Great Britain and Northern Ireland (the)
  GEO = 'geo-national-flag', // Georgia
  GGY = 'ggy-national-flag', // Guernsey
  GHA = 'gha-national-flag', // Ghana
  GIB = 'gib-national-flag', // Gibraltar
  GIN = 'gin-national-flag', // Guinea
  // GLP = 'glp-national-flag', // Guadeloupe - FLAG IS MISSING
  GMB = 'gmb-national-flag', // Gambia (the)
  GNB = 'gnb-national-flag', // Guinea-Bissau
  GNQ = 'gnq-national-flag', // Equatorial Guinea
  GRC = 'grc-national-flag', // Greece
  GRD = 'grd-national-flag', // Grenada
  GRL = 'grl-national-flag', // Greenland
  GTM = 'gtm-national-flag', // Guatemala
  GUF = 'guf-national-flag', // French Guiana
  GUM = 'gum-national-flag', // Guam
  GUY = 'guy-national-flag', // Guyana
  HKG = 'hkg-national-flag', // Hong Kong
  HMD = 'hmd-national-flag', // Heard Island and McDonald Islands
  HND = 'hnd-national-flag', // Honduras
  HRV = 'hrv-national-flag', // Croatia
  HTI = 'hti-national-flag', // Haiti
  HUN = 'hun-national-flag', // Hungary
  IDN = 'idn-national-flag', // Indonesia
  IMN = 'imn-national-flag', // Isle of Man
  IND = 'ind-national-flag', // India
  IOT = 'iot-national-flag', // British Indian Ocean Territory (the)
  IRL = 'irl-national-flag', // Ireland
  IRN = 'irn-national-flag', // Iran (Islamic Republic of)
  IRQ = 'irq-national-flag', // Iraq
  ISL = 'isl-national-flag', // Iceland
  ISR = 'isr-national-flag', // Israel
  ITA = 'ita-national-flag', // Italy
  JAM = 'jam-national-flag', // Jamaica
  JEY = 'jey-national-flag', // Jersey
  JOR = 'jor-national-flag', // Jordan
  JPN = 'jpn-national-flag', // Japan
  KAZ = 'kaz-national-flag', // Kazakhstan
  KEN = 'ken-national-flag', // Kenya
  KGZ = 'kgz-national-flag', // Kyrgyzstan
  KHM = 'khm-national-flag', // Cambodia
  KIR = 'kir-national-flag', // Kiribati
  // KNA = 'kna-national-flag', // Saint Kitts and Nevis - FLAG IS MISSING
  KOR = 'kor-national-flag', // Korea (the Republic of)
  KWT = 'kwt-national-flag', // Kuwait
  LAO = 'lao-national-flag', // Lao People's Democratic Republic (the)
  LBN = 'lbn-national-flag', // Lebanon
  LBR = 'lbr-national-flag', // Liberia
  LBY = 'lby-national-flag', // Libya
  LCA = 'lca-national-flag', // Saint Lucia
  LIE = 'lie-national-flag', // Liechtenstein
  LKA = 'lka-national-flag', // Sri Lanka
  LSO = 'lso-national-flag', // Lesotho
  LTU = 'ltu-national-flag', // Lithuania
  LUX = 'lux-national-flag', // Luxembourg
  LVA = 'lva-national-flag', // Latvia
  MAC = 'mac-national-flag', // Macao
  MAF = 'maf-national-flag', // Saint Martin (French part)
  MAR = 'mar-national-flag', // Morocco
  MCO = 'mco-national-flag', // Monaco
  MDA = 'mda-national-flag', // Moldova (the Republic of)
  MDG = 'mdg-national-flag', // Madagascar
  MDV = 'mdv-national-flag', // Maldives
  MEX = 'mex-national-flag', // Mexico
  MHL = 'mhl-national-flag', // Marshall Islands (the)
  MKD = 'mkd-national-flag', // Republic of North Macedonia
  MLI = 'mli-national-flag', // Mali
  MLT = 'mlt-national-flag', // Malta
  MMR = 'mmr-national-flag', // Myanmar
  MNE = 'mne-national-flag', // Montenegro
  MNG = 'mng-national-flag', // Mongolia
  MNP = 'mnp-national-flag', // Northern Mariana Islands (the)
  MOZ = 'moz-national-flag', // Mozambique
  MRT = 'mrt-national-flag', // Mauritania
  MSR = 'msr-national-flag', // Montserrat
  MTQ = 'mtq-national-flag', // Martinique
  MUS = 'mus-national-flag', // Mauritius
  MWI = 'mwi-national-flag', // Malawi
  MYS = 'mys-national-flag', // Malaysia
  MYT = 'myt-national-flag', // Mayotte
  NAM = 'nam-national-flag', // Namibia
  NCL = 'ncl-national-flag', // New Caledonia
  NER = 'ner-national-flag', // Niger (the)
  NFK = 'nfk-national-flag', // Norfolk Island
  NGA = 'nga-national-flag', // Nigeria
  NIC = 'nic-national-flag', // Nicaragua
  NIU = 'niu-national-flag', // Niue
  NLD = 'nld-national-flag', // Netherlands (the)
  NOR = 'nor-national-flag', // Norway
  NPL = 'npl-national-flag', // Nepal
  NRU = 'nru-national-flag', // Nauru
  NZL = 'nzl-national-flag', // New Zealand
  OMN = 'omn-national-flag', // Oman
  PAK = 'pak-national-flag', // Pakistan
  PAN = 'pan-national-flag', // Panama
  PCN = 'pcn-national-flag', // Pitcairn
  PER = 'per-national-flag', // Peru
  PHL = 'phl-national-flag', // Philippines (the)
  PLW = 'plw-national-flag', // Palau
  PNG = 'png-national-flag', // Papua New Guinea
  POL = 'pol-national-flag', // Poland
  PRI = 'pri-national-flag', // Puerto Rico
  PRK = 'prk-national-flag', // Korea (the Democratic People's Republic of)
  PRT = 'prt-national-flag', // Portugal
  PRY = 'pry-national-flag', // Paraguay
  PSE = 'pse-national-flag', // Palestine, State of
  PYF = 'pyf-national-flag', // French Polynesia
  QAT = 'qat-national-flag', // Qatar
  REU = 'reu-national-flag', // Romania
  ROU = 'rou-national-flag', // Russian Federation (the)
  RUS = 'rus-national-flag', // Rwanda
  RWA = 'rwa-national-flag', // Réunion
  SAU = 'sau-national-flag', // Saudi Arabia
  SDN = 'sdn-national-flag', // Sudan (the)
  SEN = 'sen-national-flag', // Senegal
  SGP = 'sgp-national-flag', // Singapore
  // SGS = 'sgs-national-flag', // South Georgia and the South Sandwich Islands - FLAG IS MISSING
  // SHN = 'shn-national-flag', // Saint Helena, Ascension and Tristan da Cunha - has no official flag
  // SJM = 'sjm-national-flag', // Svalbard and Jan Mayen - has no official flag
  SLB = 'slb-national-flag', // Solomon Islands
  SLE = 'sle-national-flag', // Sierra Leone
  SLV = 'slv-national-flag', // El Salvador
  SMR = 'smr-national-flag', // San Marino
  SOM = 'som-national-flag', // Somalia
  SPM = 'spm-national-flag', // Saint Pierre and Miquelon
  SRB = 'srb-national-flag', // Serbia
  SSD = 'ssd-national-flag', // South Sudan
  STP = 'stp-national-flag', // Sao Tome and Principe
  SUR = 'sur-national-flag', // Suriname
  SVK = 'svk-national-flag', // Slovakia
  SVN = 'svn-national-flag', // Slovenia
  SWE = 'swe-national-flag', // Sweden
  SWZ = 'swz-national-flag', // Eswatini
  SXM = 'sxm-national-flag', // Sint Maarten (Dutch part)
  SYC = 'syc-national-flag', // Seychelles
  SYR = 'syr-national-flag', // Syrian Arab Republic
  TCA = 'tca-national-flag', // Turks and Caicos Islands (the)
  TCD = 'tcd-national-flag', // Chad
  TGO = 'tgo-national-flag', // Togo
  THA = 'tha-national-flag', // Thailand
  TJK = 'tjk-national-flag', // Tajikistan
  TKL = 'tkl-national-flag', // Tokelau
  TKM = 'tkm-national-flag', // Turkmenistan
  TLS = 'tls-national-flag', // Timor-Leste
  TON = 'ton-national-flag', // Tonga
  TTO = 'tto-national-flag', // Trinidad and Tobago
  TUN = 'tun-national-flag', // Tunisia
  TUR = 'tur-national-flag', // Turkey
  TUV = 'tuv-national-flag', // Tuvalu
  TWN = 'twn-national-flag', // Taiwan (Province of China)
  TZA = 'tza-national-flag', // Tanzania, United Republic of
  UGA = 'uga-national-flag', // Uganda
  UKR = 'ukr-national-flag', // Ukraine
  UMI = 'umi-national-flag', // United States Minor Outlying Islands (the)
  URY = 'ury-national-flag', // Uruguay
  USA = 'usa-national-flag', // United States of America (the)
  UZB = 'uzb-national-flag', // Uzbekistan
  VAT = 'vat-national-flag', // Holy See (the)
  VCT = 'vct-national-flag', // Saint Vincent and the Grenadines
  VEN = 'ven-national-flag', // Venezuela (Bolivarian Republic of)
  VGB = 'vgb-national-flag', // Virgin Islands (British)
  VIR = 'vir-national-flag', // Virgin Islands (U.S.)
  VNM = 'vnm-national-flag', // Viet Nam
  VUT = 'vut-national-flag', // Vanuatu
  WLF = 'wlf-national-flag', // Wallis and Futuna
  WSM = 'wsm-national-flag', // Samoa
  YEM = 'yem-national-flag', // Yemen
  ZAF = 'zaf-national-flag', // South Africa
  ZMB = 'zmb-national-flag', // Zambia
  ZWE = 'zwe-national-flag', // Zimbabwe
}

export enum NationalFlagLabels {
  ABW = 'Aruba',
  AFG = 'Afghanistan',
  AGO = 'Angola',
  AIA = 'Anguilla',
  ALA = 'Åland Islands',
  ALB = 'Albania',
  AND = 'Andorra',
  ARE = 'The United Arab Emirates',
  ARG = 'Argentina',
  ARM = 'Armenia',
  ASM = 'American Samoa',
  ATA = 'Antarctica',
  ATF = 'The French Southern Territories',
  ATG = 'Antigua and Barbuda',
  AUS = 'Australia',
  AUT = 'Austria',
  AZE = 'Azerbaijan',
  BDI = 'Burundi',
  BEL = 'Belgium',
  BEN = 'Benin',
  BES = 'Bonaire, Sint Eustatius and Saba',
  BFA = 'Burkina Faso',
  BGD = 'Bangladesh',
  BGR = 'Bulgaria',
  BHR = 'Bahrain',
  BHS = 'The Bahamas',
  BIH = 'Bosnia and Herzegovina',
  BLM = 'Saint Barthélemy',
  BLR = 'Belarus',
  BLZ = 'Belize',
  BMU = 'Bermuda',
  BOL = 'Plurinational State of Bolivia',
  BRA = 'Brazil',
  BRB = 'Barbados',
  BRN = 'Brunei Darussalam',
  BTN = 'Bhutan',
  BVT = 'Bouvet Island',
  BWA = 'Botswana',
  CAF = 'The Central African Republic',
  CAN = 'Canada',
  CCK = 'The Cocos (Keeling) Islands',
  CHE = 'Switzerland',
  CHL = 'Chile',
  CHN = 'China',
  CIV = "Côte d'Ivoire",
  CMR = 'Cameroon',
  COD = 'The Congo',
  COG = 'The Democratic Republic of the Congo',
  COK = 'The Cook Islands',
  COL = 'Colombia',
  COM = 'The Comoros',
  CPV = 'Cabo Verde',
  CRI = 'Costa Rica',
  CUB = 'Cuba',
  CUW = 'Curaçao',
  CXR = 'Christmas Island',
  CYM = 'The Cayman Islands',
  CYP = 'Cyprus',
  CZE = 'Czechia',
  DEU = 'Germany',
  DJI = 'Djibouti',
  DMA = 'Dominica',
  DNK = 'Denmark',
  DOM = 'The Dominican Republic',
  DZA = 'Algeria',
  ECU = 'Ecuador',
  EGY = 'Egypt',
  ERI = 'Eritrea',
  ESH = 'Western Sahara',
  ESP = 'Spain',
  EST = 'Estonia',
  ETH = 'Ethiopia',
  FIN = 'Finland',
  FJI = 'Fiji',
  FLK = 'The Falkland Islands (Islas Malvinas)',
  FRA = 'France',
  FRO = 'The Faroe Islands',
  FSM = 'Federated States of Micronesia',
  GAB = 'Gabon',
  GBR = 'The United Kingdom of Great Britain and Northern Ireland',
  GEO = 'Georgia',
  GGY = 'Guernsey',
  GHA = 'Ghana',
  GIB = 'Gibraltar',
  GIN = 'Guinea',
  GLP = 'Guadeloupe',
  GMB = 'The Gambia',
  GNB = 'Guinea-Bissau',
  GNQ = 'Equatorial Guinea',
  GRC = 'Greece',
  GRD = 'Grenada',
  GRL = 'Greenland',
  GTM = 'Guatemala',
  GUF = 'French Guiana',
  GUM = 'Guam',
  GUY = 'Guyana',
  HKG = 'Hong Kong',
  HMD = 'Heard Island and McDonald Islands',
  HND = 'Honduras',
  HRV = 'Croatia',
  HTI = 'Haiti',
  HUN = 'Hungary',
  IDN = 'Indonesia',
  IMN = 'Isle of Man',
  IND = 'India',
  IOT = 'The British Indian Ocean Territory',
  IRL = 'Ireland',
  IRN = 'Islamic Republic of Iran',
  IRQ = 'Iraq',
  ISL = 'Iceland',
  ISR = 'Israel',
  ITA = 'Italy',
  JAM = 'Jamaica',
  JEY = 'Jersey',
  JOR = 'Jordan',
  JPN = 'Japan',
  KAZ = 'Kazakhstan',
  KEN = 'Kenya',
  KGZ = 'Kyrgyzstan',
  KHM = 'Cambodia',
  KIR = 'Kiribati',
  KNA = 'Saint Kitts and Nevis',
  KOR = 'The Republic of Korea',
  KWT = 'Kuwait',
  LAO = "The Lao People's Democratic Republic",
  LBN = 'Lebanon',
  LBR = 'Liberia',
  LBY = 'Libya',
  LCA = 'Saint Lucia',
  LIE = 'Liechtenstein',
  LKA = 'Sri Lanka',
  LSO = 'Lesotho',
  LTU = 'Lithuania',
  LUX = 'Luxembourg',
  LVA = 'Latvia',
  MAC = 'Macao',
  MAF = 'Saint Martin (French part)',
  MAR = 'Morocco',
  MCO = 'Monaco',
  MDA = 'The Republic of Moldova',
  MDG = 'Madagascar',
  MDV = 'Maldives',
  MEX = 'Mexico',
  MHL = 'The Marshall Islands',
  MKD = 'Republic of North Macedonia',
  MLI = 'Mali',
  MLT = 'Malta',
  MMR = 'Myanmar',
  MNE = 'Montenegro',
  MNG = 'Mongolia',
  MNP = 'The Northern Mariana Islands',
  MOZ = 'Mozambique',
  MRT = 'Mauritania',
  MSR = 'Montserrat',
  MTQ = 'Martinique',
  MUS = 'Mauritius',
  MWI = 'Malawi',
  MYS = 'Malaysia',
  MYT = 'Mayotte',
  NAM = 'Namibia',
  NCL = 'New Caledonia',
  NER = 'The Niger',
  NFK = 'Norfolk Island',
  NGA = 'Nigeria',
  NIC = 'Nicaragua',
  NIU = 'Niue',
  NLD = 'The Netherlands',
  NOR = 'Norway',
  NPL = 'Nepal',
  NRU = 'Nauru',
  NZL = 'New Zealand',
  OMN = 'Oman',
  PAK = 'Pakistan',
  PAN = 'Panama',
  PCN = 'Pitcairn',
  PER = 'Peru',
  PHL = 'The Philippines',
  PLW = 'Palau',
  PNG = 'Papua New Guinea',
  POL = 'Poland',
  PRI = 'Puerto Rico',
  PRK = "The Democratic People's Republic of Korea",
  PRT = 'Portugal',
  PRY = 'Paraguay',
  PSE = 'Palestine, State of',
  PYF = 'French Polynesia',
  QAT = 'Qatar',
  REU = 'Romania',
  ROU = 'The Russian Federation',
  RUS = 'Rwanda',
  RWA = 'Réunion',
  SAU = 'Saudi Arabia',
  SDN = 'The Sudan',
  SEN = 'Senegal',
  SGP = 'Singapore',
  SGS = 'South Georgia and the South Sandwich Islands',
  SHN = 'Saint Helena, Ascension and Tristan da Cunha',
  SJM = 'Svalbard and Jan Mayen',
  SLB = 'Solomon Islands',
  SLE = 'Sierra Leone',
  SLV = 'El Salvador',
  SMR = 'San Marino',
  SOM = 'Somalia',
  SPM = 'Saint Pierre and Miquelon',
  SRB = 'Serbia',
  SSD = 'South Sudan',
  STP = 'Sao Tome and Principe',
  SUR = 'Suriname',
  SVK = 'Slovakia',
  SVN = 'Slovenia',
  SWE = 'Sweden',
  SWZ = 'Eswatini',
  SXM = 'Sint Maarten (Dutch part)',
  SYC = 'Seychelles',
  SYR = 'Syrian Arab Republic',
  TCA = 'The Turks and Caicos Islands',
  TCD = 'Chad',
  TGO = 'Togo',
  THA = 'Thailand',
  TJK = 'Tajikistan',
  TKL = 'Tokelau',
  TKM = 'Turkmenistan',
  TLS = 'Timor-Leste',
  TON = 'Tonga',
  TTO = 'Trinidad and Tobago',
  TUN = 'Tunisia',
  TUR = 'Turkey',
  TUV = 'Tuvalu',
  TWN = 'Taiwan',
  TZA = 'United Republic of Tanzania',
  UGA = 'Uganda',
  UKR = 'Ukraine',
  UMI = 'The United States Minor Outlying Islands',
  URY = 'Uruguay',
  USA = 'The United States of America',
  UZB = 'Uzbekistan',
  VAT = 'The Holy See',
  VCT = 'Saint Vincent and the Grenadines',
  VEN = 'Bolivarian Republic of Venezuela',
  VGB = 'Virgin Islands (British)',
  VIR = 'Virgin Islands (U.S.)',
  VNM = 'Viet Nam',
  VUT = 'Vanuatu',
  WLF = 'Wallis and Futuna',
  WSM = 'Samoa',
  YEM = 'Yemen',
  ZAF = 'South Africa',
  ZMB = 'Zambia',
  ZWE = 'Zimbabwe',
}
